import React from 'react';
import { motion } from 'framer-motion';
import './LegalPages.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Termeni și <span className="gradient-text">Condiții</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Ultima actualizare: 4 Februarie 2026
          </motion.p>
        </div>
      </div>

      <div className="container legal-content">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <section className="legal-section">
            <h2>1. Acceptarea Termenilor</h2>
            <p>
              Prin accesarea și utilizarea aplicației suceava.taxi ("Serviciul"), operată de Euro Taxi SRL, sunteți de acord să fiți obligat de acești Termeni și Condiții. Dacă nu sunteți de acord cu oricare parte a acestor termeni, nu puteți accesa Serviciul.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Descrierea Serviciului</h2>
            <p>
              suceava.taxi oferă o platformă care conectează pasagerii cu furnizorii independenți de transport (șoferi). Euro Taxi SRL nu oferă servicii de transport în mod direct și nu este un transportator.
            </p>
            <p>
              Serviciul include:
            </p>
            <ul>
              <li>Aplicație mobilă pentru solicitarea curselor</li>
              <li>Urmărire GPS în timp real</li>
              <li>Procesare plăți</li>
              <li>Evaluări șoferi și pasageri</li>
              <li>Suport clienți</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Conturi de Utilizator</h2>
            <p>
              Pentru a utiliza Serviciul, trebuie să creați un cont. Sunteți de acord să:
            </p>
            <ul>
              <li>Furnizați informații exacte, actuale și complete</li>
              <li>Mențineți securitatea datelor de autentificare ale contului dvs.</li>
              <li>Ne notificați imediat în cazul oricărui acces neautorizat</li>
              <li>Fiți responsabil pentru toate activitățile din contul dvs.</li>
              <li>Aveți minimum 18 ani</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Rezervări și Plăți</h2>
            <p>
              Când solicitați o cursă, sunteți de acord să plătiți tariful afișat în aplicație plus orice taxe, tarife sau majorări aplicabile. Metodele de plată includ:
            </p>
            <ul>
              <li>Carduri de credit sau debit</li>
              <li>Portofele digitale</li>
              <li>Numerar (unde este disponibil)</li>
            </ul>
            <p>
              Toate tarifele sunt finale odată ce călătoria este finalizată. Se pot aplica taxe de anulare conform specificațiilor din aplicație.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Conduita Utilizatorului</h2>
            <p>
              Sunteți de acord să nu:
            </p>
            <ul>
              <li>Încălcați legile sau reglementările aplicabile</li>
              <li>Hărțuiți, abuzați sau dăunați șoferilor sau altor utilizatori</li>
              <li>Folosiți Serviciul pentru activități ilegale</li>
              <li>Furnizați informații false sau să vă dați drept altcineva</li>
              <li>Interferați cu funcționarea corectă a Serviciului</li>
              <li>Încercați să obțineți acces neautorizat la sistemele noastre</li>
              <li>Folosiți sisteme automate pentru a accesa Serviciul</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Anulări și Rambursări</h2>
            <p>
              Puteți anula o solicitare de cursă înainte ca șoferul să ajungă. Taxele de anulare se pot aplica în funcție de:
            </p>
            <ul>
              <li>Timpul scurs de la rezervare</li>
              <li>Proximitatea șoferului față de locația de ridicare</li>
              <li>Reglementările locale</li>
            </ul>
            <p>
              Rambursările sunt emise la discreția noastră pentru probleme de serviciu sau erori de facturare.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Evaluări și Recenzii</h2>
            <p>
              După fiecare călătorie, pasagerii și șoferii se pot evalua reciproc. Aceste evaluări ajută la menținerea calității serviciului. Ne rezervăm dreptul de a:
            </p>
            <ul>
              <li>Elimina recenziile necorespunzătoare</li>
              <li>Suspenda conturile cu evaluări constant scăzute</li>
              <li>Utiliza evaluările pentru îmbunătățirea serviciilor noastre</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Răspundere și Declarații de Exonerare</h2>
            <p>
              Serviciul este furnizat "ca atare", fără garanții de niciun fel. Nu suntem răspunzători pentru:
            </p>
            <ul>
              <li>Acțiunile sau conduita șoferilor sau pasagerilor</li>
              <li>Pierderea sau deteriorarea bunurilor personale</li>
              <li>Întârzieri sau întreruperi ale serviciului</li>
              <li>Erori în datele GPS sau de cartografiere</li>
              <li>Dispute între pasageri și șoferi</li>
            </ul>
            <p>
              Răspunderea noastră maximă este limitată la suma plătită pentru cursa specifică în cauză.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Asigurare și Siguranță</h2>
            <p>
              Toți șoferii care operează prin platforma noastră trebuie să mențină o acoperire de asigurare adecvată. Cu toate acestea, chestiunile de asigurare sunt în principal între șofer și furnizorul său de asigurări.
            </p>
            <p>
              Caracteristicile de siguranță includ:
            </p>
            <ul>
              <li>Verificări de antecedente pentru șoferi</li>
              <li>Urmărirea cursei în timp real</li>
              <li>Partajarea contactelor de urgență</li>
              <li>Linie de suport 24/7</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>10. Proprietate Intelectuală</h2>
            <p>
              Tot conținutul, funcționalitățile și caracteristicile Serviciului sunt deținute de Euro Taxi SRL și sunt protejate prin drepturi de autor, mărci comerciale și alte legi privind proprietatea intelectuală. Nu puteți:
            </p>
            <ul>
              <li>Copia sau modifica orice parte a Serviciului</li>
              <li>Utiliza mărcile noastre comerciale fără permisiune</li>
              <li>Crea lucrări derivate</li>
              <li>Ingineria inversă a software-ului nostru</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>11. Confidențialitate</h2>
            <p>
              Utilizarea dvs. a Serviciului este, de asemenea, guvernată de Politica noastră de Confidențialitate. Prin utilizarea Serviciului, consimțiți la colectarea și utilizarea datelor personale așa cum este descris în Politica de Confidențialitate.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Modificări ale Termenilor</h2>
            <p>
              Ne rezervăm dreptul de a modifica acești Termeni în orice moment. Vom notifica utilizatorii cu privire la modificările importante prin aplicație sau prin e-mail. Utilizarea continuă a Serviciului după modificări constituie acceptarea noilor Termeni.
            </p>
          </section>

          <section className="legal-section">
            <h2>13. Încetarea</h2>
            <p>
              Putem suspenda sau încheia contul dvs. în orice moment pentru:
            </p>
            <ul>
              <li>Încălcarea acestor Termeni</li>
              <li>Activitate frauduloasă</li>
              <li>Comportament abuziv</li>
              <li>Neplată</li>
              <li>Orice alt motiv la discreția noastră</li>
            </ul>
            <p>
              De asemenea, puteți încheia contul dvs. în orice moment prin setările aplicației.
            </p>
          </section>

          <section className="legal-section">
            <h2>14. Soluționarea Disputelor</h2>
            <p>
              Orice dispută care rezultă din acești Termeni sau din utilizarea Serviciului va fi rezolvată prin:
            </p>
            <ul>
              <li>Negociere cu bună-credință</li>
              <li>Mediere, dacă este necesar</li>
              <li>Arbitraj obligatoriu în conformitate cu legile locale</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>15. Legea Aplicabilă</h2>
            <p>
              Acești Termeni sunt guvernați de legile Uniunii Europene și ale țării în care este furnizat Serviciul, fără a ține cont de principiile conflictului de legi.
            </p>
          </section>

          <section className="legal-section">
            <h2>16. Informații de Contact</h2>
            <p>
              Pentru întrebări despre acești Termeni, vă rugăm să ne contactați:
            </p>
            <ul>
              <li>Email: legal@suceava.taxi</li>
              <li>Suport: contact@suceava.taxi</li>
              <li>Telefon: 0744 511 111 sau 0230 511 111</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>17. Separabilitate</h2>
            <p>
              Dacă orice prevedere a acestor Termeni este considerată inaplicabilă, prevederile rămase vor continua să fie în vigoare și efect deplin.
            </p>
          </section>

          <section className="legal-section">
            <h2>18. Acordul Complet</h2>
            <p>
              Acești Termeni, împreună cu Politica noastră de Confidențialitate, constituie acordul complet între dvs. și Euro Taxi SRL cu privire la utilizarea Serviciului.
            </p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default Terms;
